@if (show()) {
  <nav
    id="app-side-nav"
    [class.is-expanded]="isExpanded()"
    [class.with-header-visible]="isHeaderVisible()">
    <div class="nav-items">
      @for (item of navItems(); track item.id) {
        <topo-nav-item
          [navItem]="item"
          [isSideNavExpanded]="isExpanded()" />
      }
    </div>
    <div
      class="nav-item expansion-control"
      (click)="toggleExpansion()">
      <i
        class="icon icon-caret_right"
        [class.rotated]="isExpanded()"
        style="font-size: 24px"></i>
    </div>
  </nav>
}
